export default __webpack_public_path__ + "src/images/system_preface/9-cc6255.png";